class VideoAutoplayCheck {
    private static _instance: VideoAutoplayCheck;
    public allow: boolean;

    private constructor() {
        this.allow = null;

        this.playVideo().then(() => {
            if (this.allow === null) {
                this.allow = true;
                if (document.getElementById("videoId"))
                    document.getElementById("videoId").remove()
            }
        })
    }

    private async playVideo() {
        try {
            this.allow = true;
            await (document.getElementById("videoId") as HTMLVideoElement).play()
        } catch (err) {
            this.allow = false;
            document.body.classList.add("autoplay-disallowed");
        }
    }

    public static getInstance(): VideoAutoplayCheck {
        return this._instance || (this._instance = new this());
    }
}

export default VideoAutoplayCheck
export const videoAutoplayCheck = VideoAutoplayCheck.getInstance();
